import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const CoachingFilledIcon = props => (
  <Svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
    {...props}>
    <Path
      fill="#3876AA"
      fillRule="evenodd"
      d="M5.392 9.971c0-3.202 2.57-5.797 5.738-5.797 3.17 0 5.739 2.595 5.739 5.797 0 3.202-2.57 5.797-5.739 5.797s-5.738-2.595-5.738-5.797Z"
      clipRule="evenodd"
    />
    <Path
      fill="#3876AA"
      d="M.667 23.115C.667 20.29 2.933 18 5.73 18h.46c.25 0 .497.04.733.118l1.17.385a9.695 9.695 0 0 0 6.076 0l1.169-.385c.237-.078.484-.118.733-.118h.46c2.797 0 5.064 2.29 5.064 5.115v1.621a2.09 2.09 0 0 1-1.74 2.069 53.597 53.597 0 0 1-17.448 0 2.09 2.09 0 0 1-1.74-2.069v-1.62Z"
    />
    <Path
      fill="#3876AA"
      fillRule="evenodd"
      d="M12.457 2.758A5.704 5.704 0 0 1 16.869.667c3.17 0 5.739 2.595 5.739 5.797 0 2.8-1.966 5.137-4.58 5.679a7.37 7.37 0 0 0 .335-2.202c0-3.577-2.545-6.554-5.906-7.183Zm2.38 13.498-.146.046a7.256 7.256 0 0 0 1.39-1.035 9.696 9.696 0 0 0 3.827-.456l1.168-.386c.237-.078.485-.118.734-.118h.46c2.797 0 5.063 2.29 5.063 5.115v1.621a2.09 2.09 0 0 1-1.74 2.07 53.55 53.55 0 0 1-2.633.367v-.99c0-3.524-2.943-6.381-6.573-6.381h-.598c-.323 0-.645.05-.952.147Z"
      clipRule="evenodd"
    />
  </Svg>
);
export default CoachingFilledIcon;
